import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-products',
  standalone: true,
  imports: [TranslateModule],
  templateUrl: './products.component.html',
  styleUrls: ['./products.component.scss']
})
export class ProductsComponent {
  readonly demoSrc = 'assets/images/products-demo.png';
  readonly demoSecondarySrc = 'assets/images/products-demo-secondary.png';
}

